import React, { forwardRef } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import { SnackbarContent } from "notistack";
import { Icon, RenderIf } from "src/components/core/index";
import { useSnackbar } from "src/utils/hook/base/baseserviceindex";
import RenderIcon from "./RenderIcon";
import StyledSnackbar from "./styles";

const CustomSnackbar = forwardRef((props, ref) => {
  const { id, theme, title, desc } = props;

  const { closeSnack } = useSnackbar();

  return (
    <SnackbarContent ref={ref}>
      <StyledSnackbar variant={theme} gap={0.8}>
        <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
          <Stack flexDirection="row" alignItems="center" gap={1.5}>
            <RenderIcon theme={theme} />
            <Typography variant="body1" color="white">
              {title}
            </Typography>
          </Stack>
          <IconButton onClick={() => closeSnack(id)}>
            <Icon name="close-line" color={(pallete) => pallete.common.white} />
          </IconButton>
        </Stack>
        <RenderIf isTrue={!!desc}>
          <Typography variant="subtitle" color="white">
            {desc}
          </Typography>
        </RenderIf>
      </StyledSnackbar>
    </SnackbarContent>
  );
});

export default CustomSnackbar;

// declare displayName
CustomSnackbar.displayName = "CustomSnackbar";
